import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Button, List, ListItem, ListItemText } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import BookForm from './BookForm';
import { getBooks, setDisplayedStatus } from '../redux/actions';
import { BookTemplate, ReduxState } from '../types';


const useStyles = makeStyles((theme) => ({
  root: {
    height: '75vh',
    maxHeight: '500px',
    paddingRight: '1rem',
    borderRight: `solid 1px ${theme.palette.divider}`,
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    overflow: 'auto',
    '& .MuiListItem-root': {
        borderRight: 'solid 5px transparent',
    },
    '& .Mui-selected': {
        backgroundColor: 'transparent',
        borderRight: `solid 5px ${theme.palette.primary.main}`,
    }
  },
}));


const STATUS_LABELS = ['backlog', 'reading', 'completed'];
const EMPTY_BOOK_TEMPLATE: BookTemplate = {
    title: '',
    authors: '',
    status: 'backlog',
};


const Sidebar = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const displayedStatus = useSelector((state: ReduxState) => state.displayedStatus);

  const [bookFormIsOpen, toggleBookForm] = React.useState<boolean>(false);

  const handleToggleBookForm = () => {
    toggleBookForm(!bookFormIsOpen);
  }

  const handleSetDisplayedStatus = (newStatus: string) => {
    dispatch(setDisplayedStatus(newStatus));
    dispatch(getBooks(newStatus));
  }

  const bookFormProps = {
    defaultValues: EMPTY_BOOK_TEMPLATE,
    isOpen: bookFormIsOpen,
    closeForm: handleToggleBookForm,
  };
  
  return (
    <div className={classes.root}>
        <List>
            {
                STATUS_LABELS.map((label, index) => (
                    <ListItem 
                        key={index} 
                        button
                        selected={label === displayedStatus}
                        onClick={() => handleSetDisplayedStatus(label)}
                    >
                        <ListItemText 
                            primary={label} 
                            primaryTypographyProps={{align: 'right'}}
                        />
                    </ListItem>
                ))
            }
        </List>
        <Button
            color="primary"
            disableElevation
            startIcon={<AddIcon />}
            variant="contained"
            onClick={handleToggleBookForm}
        >
            Add book
        </Button>
        <BookForm { ...bookFormProps } />
    </div>
  );
}

export default Sidebar;